import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Top from "../components/Top";
import Navbar from "../components/Navbar";

const ChangePassword = ({ currentUser }) => {
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [serverError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading((prev) => !prev);
    try {
      let response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/api/v1/user/change-password`,
        data,
        { withCredentials: true }
      );

      setLoading((prev) => !prev);
      toast.success(response.data.message);
      navigate("/");
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
    }
  };

  return (
    <div className="py-6 px-3 xl:px-8">
      <Top currentUser={currentUser} />
      <Navbar currentUser={currentUser} />

      <div className="bg-white rounded-lg px-0 xl:px-8 sm:px-6 p-8 pt-0 mt-6 w-full sm:w-[450px] xl:w-[520px] mx-auto">
        <h2 className=" font-semibold text-[24px] xl:text-[32px] 2xl:text-[36px] xxl:text-4xl  leading-none tracking-normal text-[#5D0E23]">
          Change Password
        </h2>

        {serverError && (
          <p className="text-red-500 text-center mb-4">{serverError}</p>
        )}

        <form
          className="mt-4 2xl:mt-5 flex flex-col gap-2"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="mb-2">
            <input
              type="oldPassword"
              id="oldPassword"
              {...register("oldPassword", {
                required: "Old Password is required.",
              })}
              className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.oldPassword ? "border-red-500" : ""
                }`}
              placeholder="Old Password"
            />
            {errors.oldPassword && (
              <p className="text-red-500 text-xs italic">
                {errors.oldPassword.message}
              </p>
            )}
          </div>

          <div className="mb-2">
            <input
              autoComplete="new-password"
              type="newPassword"
              id="newPassword"
              {...register("newPassword", {
                required: "New Password is required.",
              })}
              className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.newPassword ? "border-red-500" : ""
                }`}
              placeholder="New Password"
            />
            {errors.newPassword && (
              <p className="text-red-500 text-xs italic">
                {errors.newPassword.message}
              </p>
            )}
          </div>

          <div className="mb-2">
            <input
              autoComplete="new-password"
              type="confirmPassword"
              id="confirmPassword"
              {...register("confirmPassword", {
                required: "Confirm Password is required.", pattern: {
                  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/,
                  message:
                    "Password must be 8+ characters with 1 uppercase, 1 lowercase, 1 number, and 1 special character",
                },
              })}
              className={`text-[12px] xl:text-[16px] appearance-none border border-[#797979]  rounded w-full py-3 px-5 text-[#47474A] leading-tight focus:outline-none  ${errors.confirmPassword ? "border-red-500" : ""
                }`}
              placeholder="Confirm Password"
            />
            {errors.confirmPassword ?
              <p className="text-red-500 text-xs italic">
                {errors.confirmPassword.message}
              </p> :
              <p className="text-xs italic mt-1">
                Password must be 8+ characters with 1 uppercase, 1 lowercase, 1 number, and 1 special character
              </p>

            }
          </div>
          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="cursor-pointer  font-semibold text-[20px] xl:text-[18px] rounded-[6px] xl:rounded-[6px] mt-2 2xl:mt-3 2xl:rounded-[8px] xxl:rounded-[10px] 2xl:text-[20px] xxl:text-2xl leading-none tracking-normal bg-[#7F132F] w-[55%] hover:bg-[#55051A] text-white py-3 focus:outline-none "
            >
              {loading ? <ClipLoader size={"1em"} color="white" /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
